import React, { useCallback, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { Button, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import VisibilityIcon from '@mui/icons-material/Visibility'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'

import AlertDialog from '../dialogs/ConfirmDialog'
import useRole from '../../useUserRole'

import {
  TileButton,
  TileCard,
  TileCardActions,
  TileCardContent,
  TileDeleteButton,
} from '../../styles/components/SetupTileStyle'
import statisticsApi from '../../api/statistics'
import useHandleError from '../../api/useHandleError'

const SetupTile = ({ id, index, title, tiles, setTiles }) => {
  const { userRole } = useRole()
  const [isDialogOpen, setIsOpenDialog] = useState(false)
  const handleError = useHandleError()

  const navigate = useNavigate()
  const handleClick = useCallback((e) => navigate(`/statistics/${e.currentTarget.name}/${id}`), [navigate, id])

  const handleDelete = () => {
    setTiles(tiles.filter((tile) => tile.id !== id))
    statisticsApi.deleteTile(id).catch(handleError)
    handleDialog()
  }

  const handleDialog = () => {
    setIsOpenDialog(!isDialogOpen)
  }

  return (
    <TileCard aria-label={`tile-${index}`} elevation={4}>
      {userRole === 'admin' && (
        <TileDeleteButton onClick={handleDialog} aria-label={`removeTileButton-${index}`}>
          <DeleteForeverIcon />
        </TileDeleteButton>
      )}
      <TileCardContent>
        <Typography variant="h5" component="h2">
          {title}
        </Typography>
      </TileCardContent>

      <TileCardActions>
        {userRole === 'admin' && (
          <TileButton onClick={handleClick} name="edit" startIcon={<EditIcon />} aria-label={`editTileButton-${index}`}>
            Edit
          </TileButton>
        )}

        <TileButton
          onClick={handleClick}
          name="view"
          startIcon={<VisibilityIcon />}
          aria-label={`viewTileButton-${index}`}
        >
          View mode
        </TileButton>
      </TileCardActions>

      <AlertDialog
        isDialogOpen={isDialogOpen}
        title="Delete statistics tile"
        description={`Are you sure you want to delete tile "${title}"?`}
      >
        <Button onClick={handleDialog} autoFocus aria-label="cancelRemoveTileButton">
          Cancel
        </Button>
        <Button onClick={handleDelete} aria-label="confirmRemoveTileButton">
          Delete
        </Button>
      </AlertDialog>
    </TileCard>
  )
}

SetupTile.propTypes = {
  id: PropTypes.number,
  index: PropTypes.number,
  title: PropTypes.string,
  tiles: PropTypes.array,
  setTiles: PropTypes.func,
}

export default SetupTile
